import { Capacitor } from '@capacitor/core';

import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'zwi-simple-page',
    templateUrl: './simple-page.component.html',
    styleUrls: ['./simple-page.component.scss'],
    standalone: false
})
export class SimplePageComponent implements OnInit {
  isNativePlatform = Capacitor.isNativePlatform();

  constructor() {}

  ngOnInit(): void {}
}
